<template>
  <form action="">
    <template v-if="thankyou">
      <div class="text-center" v-html="$t('general.newsletter.thankyou')"></div>
    </template>
    <template v-else>
      <div class="form-group">
        <input type="text" :class="['form-control', {'is-invalid': errors.has('name')}]" v-model="form.name" :placeholder="$t('welcome.newsletter.form.name')">
      </div>
      <div class="form-group">
        <input type="text" :class="['form-control', {'is-invalid': errors.has('email')}]" v-model="form.email" :placeholder="$t('welcome.newsletter.form.email')">
      </div>
      <div class="form-group">
        <div class="checkbox">
          <label>
            <input type="checkbox" name="confirm" value="1" v-model="form.confirm">
            <span :class="['left smallLineHeight', {'is-invalid': errors.has('confirm')}]" v-html="`${$t('welcome.newsletter.form.privacy')}`"></span>
          </label>
        </div>
      </div>
      <button class="btn btn-green w-100" @click.prevent="submit" :disabled="loading">{{ $t('welcome.newsletter.form.btn') }}</button>
    </template>
  </form>
</template>

<script>
import Errors from '@Core/errors'
import XHR from '@Core/xhr'
import to from '@Utils/to'

export default {
  data () {
    return {
      thankyou: false,
      loading: false,
      errors: new Errors(),
      form: new XHR({
        name: '',
        email: '',
        confirm: ''
      })
    }
  },

  methods: {
    async submit () {
      this.loading = true
      let [errors, response] = await to(this.form.post('/newsletter'))
      this.loading = false

      this.errors = errors || new Errors()
      !errors && response.success && this.showThankyou() && this.form.reset()
    },

    showThankyou () {
      this.thankyou = true
      setTimeout(() => { this.thankyou = false }, 4000)

      return true
    }
  }

}
</script>
